<template>
  <v-container class="mb-5" v-editable="blok">
    <v-row justify="center">
      <v-col cols="12">
        <figure class="my-5">
          <img src="@/assets/logo_mini_light.svg" />
        </figure>
       
      </v-col>
      <v-col cols="8" md="10" lg="7">
        <carousel class="mb-5" :autoplay="true" :loop="true" :autoplayTimeout="6000" :speed="1000" paginationColor="#efefef" paginationActiveColor="#20316D" :paginationSize="17" :perPageCustom="[[320, 1], [700, 2], [980, 3] ]">
          <slide v-for="(item, i) in blok.images" :key="i">
          <a :to="item.link">
            <img :src="item.image" style="width:100%; max-width:202px">
          </a>
          </slide>
        </carousel>
      </v-col>
      <v-col cols="8" md="10" lg="7">
        <p v-html="blok.description"></p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  data() {
    return {
      
    };
  },
  props: ["blok"]
};
</script>

<style lang="scss" scoped>
@import "./Experience.scss";
</style>